import { useCustomSuspenseQuery } from "@/hooks/use-graphql-client";

import { RoomList_DesignPage_Query } from "./query";

type Props = {
	hotelID: string;
};

export const useRoomListQuery = ({ hotelID }: Props) => {
	const { data } = useCustomSuspenseQuery(RoomList_DesignPage_Query, { variables: { hotelID } });

	return {
		data,
	};
};
